module.exports = __webpack_public_path__ + "img/elevateLogo.03af87e4.png";